var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImportPriceSeries({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9987 15.4999V19.4999H2.9987V15.4999H0.332031V19.4999C0.332031 20.9666 1.53203 22.1666 2.9987 22.1666H18.9987C20.4654 22.1666 21.6654 20.9666 21.6654 19.4999V15.4999H18.9987ZM4.33203 7.49992L6.21203 9.37992L9.66536 5.93992V16.8333H12.332V5.93992L15.7854 9.37992L17.6654 7.49992L10.9987 0.833252L4.33203 7.49992Z",
    fill: "#2246DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportPriceSeries);
export default __webpack_public_path__ + "static/media/import-price-series.c83640008badcbfa02ce2872535dcac8.svg";
export { ForwardRef as ReactComponent };